import { default as empRaisesTypes } from "./types";

const {
  ADD_EMP_RAISE_REQUEST,
  ADD_EMP_RAISE_SUCCESS,
  ADD_EMP_RAISE_FAILURE,
  EDIT_EMP_RAISE_REQUEST,
  EDIT_EMP_RAISE_SUCCESS,
  EDIT_EMP_RAISE_FAILURE,
  DELETE_EMP_RAISE_REQUEST,
  DELETE_EMP_RAISE_SUCCESS,
  DELETE_EMP_RAISE_FAILURE,
  FETCH_EMP_RAISES_REQUEST,
  FETCH_EMP_RAISES_SUCCESS,
  FETCH_EMP_RAISES_FAILURE,
  CLEAR_EMP_RAISE,
} = empRaisesTypes;

const initialState = {
  isLoading: false,
  list: [],
  detail: null,
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EMP_RAISE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_EMP_RAISE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case ADD_EMP_RAISE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case EDIT_EMP_RAISE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case EDIT_EMP_RAISE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case EDIT_EMP_RAISE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case DELETE_EMP_RAISE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_EMP_RAISE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case DELETE_EMP_RAISE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_EMP_RAISES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_EMP_RAISES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_EMP_RAISES_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    case CLEAR_EMP_RAISE:
      return {
        ...state,
        isLoading: false,
        detail: null,
        error: "",
      };
    default:
      return state;
  }
};

export default reducer;
